
    const data = {"name":"src/core/icons/format-align-left","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 3h18v2H3V3m0 4h12v2H3V7m0 4h18v2H3v-2m0 4h12v2H3v-2m0 4h18v2H3v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            